module.exports = __webpack_public_path__ + "img/album21_01.033642e4.jpg";